import LineDelimiter from './line-delimiter';

export default LineDelimiter;
